(function(){
if(window.__ssMacMobileGalleryLoopTrueSeparateV15)return;
window.__ssMacMobileGalleryLoopTrueSeparateV15=true;
var mqMobile=window.matchMedia('(max-width: 749px)');
var mqFine=window.matchMedia('(hover: hover) and (pointer: fine)');
var states=new WeakMap();
var activeState=null;
function isMacMobile(){
return mqMobile.matches&&mqFine.matches&&!('ontouchstart' in window)&&(((navigator&&navigator.maxTouchPoints)||0)===0);
}
function mod(n,m){return ((n%m)+m)%m;}
function getWidth(state){
return Math.round(state.frame.getBoundingClientRect().width||state.gallery.getBoundingClientRect().width||window.innerWidth||0);
}
function getOriginalItems(move){
var all=Array.prototype.slice.call(move.querySelectorAll('.product-detail-gallery--item'));
var seen=Object.create(null);
var originals=[];
all.forEach(function(item){
var key=item.getAttribute('data-ss-media-key')||'';
if(!key)return;
if(seen[key])return;
seen[key]=true;
originals.push(item);
});
return originals;
}
function rebuildIfNeeded(state){
var originals=getOriginalItems(state.move);
if(originals.length<2)return false;
var key=originals.map(function(item){return item.getAttribute('data-ss-media-key')||'';}).join('|');
if(state.key===key&&state.count===originals.length&&state.items.length===originals.length*3)return true;
state.key=key;
state.count=originals.length;
state.move.innerHTML='';
for(var round=0;round<3;round++){
originals.forEach(function(item){
var clone=item.cloneNode(true);
clone.classList.remove('active');
clone.setAttribute('data-ss-mac-mobile-loop-copy',String(round));
state.move.appendChild(clone);
});
}
state.items=Array.prototype.slice.call(state.move.querySelectorAll('.product-detail-gallery--item'));
state.realIndex=0;
state.visualIndex=state.count;
return true;
}
function setActive(state){
var real=mod(state.realIndex,state.count);
state.items.forEach(function(item,i){
item.classList.toggle('active',mod(i,state.count)===real&&i===state.visualIndex);
});
}
function applyLayout(state){
if(!isMacMobile())return;
if(!rebuildIfNeeded(state))return;
var w=getWidth(state);
if(!w)return;
state.width=w;
state.gallery.style.opacity='1';
state.frame.style.setProperty('overflow','hidden','important');
state.frame.style.setProperty('overflow-x','hidden','important');
state.frame.style.setProperty('overflow-y','hidden','important');
state.frame.style.setProperty('scroll-snap-type','none','important');
state.frame.style.setProperty('scroll-behavior','auto','important');
state.frame.style.setProperty('overscroll-behavior-x','contain','important');
state.frame.style.setProperty('cursor','default','important');
state.move.style.setProperty('cursor','default','important');
state.frame.scrollLeft=0;
state.move.style.setProperty('display','flex','important');
state.move.style.setProperty('width',(w*state.items.length)+'px','important');
state.move.style.setProperty('transition','none','important');
state.move.style.setProperty('will-change','transform','important');
state.items.forEach(function(item){
item.style.setProperty('display','block','important');
item.style.setProperty('flex','0 0 '+w+'px','important');
item.style.setProperty('width',w+'px','important');
item.style.setProperty('scroll-snap-align','none','important');
item.style.setProperty('cursor','default','important');
var imgs=item.querySelectorAll('img');
Array.prototype.forEach.call(imgs,function(img){img.style.setProperty('cursor','default','important');});
});
state.visualIndex=state.count+mod(state.realIndex,state.count);
state.move.style.setProperty('transform','translate3d(-'+(state.visualIndex*w)+'px,0,0)','important');
setActive(state);
}
function normalizeAfterMove(state){
state.realIndex=mod(state.realIndex,state.count);
state.visualIndex=state.count+state.realIndex;
state.move.style.setProperty('transition','none','important');
state.move.style.setProperty('transform','translate3d(-'+(state.visualIndex*state.width)+'px,0,0)','important');
setActive(state);
}
function go(state,delta){
if(!isMacMobile()||state.animating||!state.count)return;
applyLayout(state);
var from=state.visualIndex;
var to=from+delta;
state.animating=true;
state.realIndex=mod(state.realIndex+delta,state.count);
state.visualIndex=to;
state.move.style.setProperty('transition','transform 115ms cubic-bezier(0.22,0.61,0.36,1)','important');
state.move.style.setProperty('transform','translate3d(-'+(to*state.width)+'px,0,0)','important');
markMoved(state);
window.setTimeout(function(){
state.animating=false;
if(!isMacMobile())return;
normalizeAfterMove(state);
},125);
}
function initGallery(gallery){
if(!gallery||states.has(gallery))return;
var frame=gallery.querySelector('.product-detail-gallery__frame');
var move=gallery.querySelector('.product-detail-gallery__move');
if(!frame||!move)return;
var state={gallery:gallery,frame:frame,move:move,items:[],count:0,key:'',realIndex:0,visualIndex:0,width:0,animating:false,wheelSum:0,lastWheelAt:0,lockUntil:0,gestureConsumed:false,gestureQuietTimer:null,lastMoveAt:0,lastWheelAbs:0};
states.set(gallery,state);
applyLayout(state);
frame.addEventListener('dragstart',function(e){if(isMacMobile())e.preventDefault();},true);
frame.addEventListener('mousedown',function(e){if(isMacMobile())e.preventDefault();},true);
frame.addEventListener('click',function(e){
if(!isMacMobile())return;
if(e.button&&e.button!==0)return;
if(state.animating)return;
var interactive=e.target&&e.target.closest?e.target.closest('a,button,input,select,textarea,label,summary,[role=button]'):null;
if(interactive)return;
var r=frame.getBoundingClientRect();
if(!r.width)return;
var x=e.clientX-r.left;
var dir=x>=r.width/2?1:-1;
e.preventDefault();
e.stopPropagation();
if(e.stopImmediatePropagation)e.stopImmediatePropagation();
state.gestureConsumed=false;
if(state.gestureQuietTimer){window.clearTimeout(state.gestureQuietTimer);state.gestureQuietTimer=null;}
resetWheel(state);
go(state,dir);
},true);
}
function init(){
document.querySelectorAll('.product-detail-gallery').forEach(initGallery);
if(isMacMobile())states.forEach?null:null;
}
function visibleStateFromEventTarget(target){
if(target&&target.closest){
var direct=target.closest('.product-detail-gallery');
if(direct&&states.has(direct))return states.get(direct);
}
var galleries=Array.prototype.slice.call(document.querySelectorAll('.product-detail-gallery'));
for(var i=0;i<galleries.length;i++){
var state=states.get(galleries[i]);
if(!state)continue;
var r=galleries[i].getBoundingClientRect();
if(r.width>0&&r.height>0&&r.bottom>0&&r.top<window.innerHeight)return state;
}
return null;
}
function resetWheel(state){
state.wheelSum=0;
}
function holdUntilWheelQuiet(state,quietMs){
if(state.gestureQuietTimer)window.clearTimeout(state.gestureQuietTimer);
state.gestureConsumed=true;
state.gestureQuietTimer=window.setTimeout(function(){
state.gestureConsumed=false;
state.gestureQuietTimer=null;
state.lastWheelAbs=0;
resetWheel(state);
},quietMs||54);
}
function markMoved(state){
state.lastMoveAt=(window.performance&&performance.now)?performance.now():Date.now();
state.lastWheelAbs=0;
}
function canTreatAsNewPulse(state,adx,now){
if(state.animating)return false;
if(!state.lastMoveAt)return false;
if(now-state.lastMoveAt<138)return false;
return adx>=18&&adx>state.lastWheelAbs*1.45;
}
function onWheel(e){
if(!isMacMobile())return;
var dx=e.deltaX||0;
var dy=e.deltaY||0;
var adx=Math.abs(dx);
if(adx<Math.max(4,Math.abs(dy)*1.12))return;
var state=visibleStateFromEventTarget(e.target);
if(!state)return;
activeState=state;
if(e.cancelable)e.preventDefault();
e.stopPropagation();
if(e.stopImmediatePropagation)e.stopImmediatePropagation();
applyLayout(state);
var now=(window.performance&&performance.now)?performance.now():Date.now();
var gap=state.lastWheelAt?now-state.lastWheelAt:999;
state.lastWheelAt=now;
if(state.gestureConsumed){
if(canTreatAsNewPulse(state,adx,now)){
state.gestureConsumed=false;
resetWheel(state);
}else{
state.lastWheelAbs=adx;
holdUntilWheelQuiet(state,54);
return;
}
}
if(state.animating){
state.lastWheelAbs=adx;
holdUntilWheelQuiet(state,54);
return;
}
if(gap>90)resetWheel(state);
if((state.wheelSum>0&&dx<0)||(state.wheelSum<0&&dx>0))resetWheel(state);
state.wheelSum+=dx;
if(Math.abs(state.wheelSum)>=16){
var dir=state.wheelSum>0?1:-1;
resetWheel(state);
holdUntilWheelQuiet(state,54);
go(state,dir);
}
}
function onResize(){
window.clearTimeout(onResize.t);
onResize.t=window.setTimeout(function(){
document.querySelectorAll('.product-detail-gallery').forEach(function(gallery){
var state=states.get(gallery);
if(state)applyLayout(state);
});
},80);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
window.addEventListener('load',init,{passive:true});
window.addEventListener('pageshow',init,{passive:true});
window.addEventListener('resize',onResize,{passive:true});
document.addEventListener('shopify:section:load',function(){setTimeout(init,0);});
document.addEventListener('wheel',onWheel,{capture:true,passive:false});
setTimeout(init,300);
setTimeout(init,1200);
})();

/* SS product gallery breakpoint hard refresh v3 fast
   Mac/PC only: reload immediately after crossing desktop/mobile breakpoint. */
(function(){
if(window.__ssProductGalleryBreakpointHardRefreshV3Fast)return;
window.__ssProductGalleryBreakpointHardRefreshV3Fast=true;
function isProductPage(){
return document.body&&(
  document.body.classList.contains('template-product')||
  document.body.classList.contains('product')||
  document.querySelector('.product-detail-gallery')
);
}
function isDesktopEnvironment(){
return window.matchMedia('(hover: hover) and (pointer: fine)').matches&&
  !('ontouchstart' in window)&&
  (((navigator&&navigator.maxTouchPoints)||0)===0);
}
function mode(){
return window.matchMedia('(max-width: 749px)').matches?'mobile':'desktop';
}
var initialMode=mode();
var lastMode=initialMode;
var timer=null;
function shouldReload(){
if(!isProductPage())return false;
if(!isDesktopEnvironment())return false;
var now=Date.now();
var last=Number(sessionStorage.getItem('ssGalleryBreakpointReloadAt')||0);
if(now-last<1600)return false;
return true;
}
function reloadForBreakpoint(){
if(!shouldReload())return;
try{sessionStorage.setItem('ssGalleryBreakpointReloadAt',String(Date.now()));}catch(e){}
window.location.reload();
}
window.addEventListener('resize',function(){
var current=mode();
if(current===lastMode)return;
lastMode=current;
window.clearTimeout(timer);
timer=window.setTimeout(reloadForBreakpoint,30);
},{passive:true});
})();
